module.exports = __webpack_public_path__ + "static/media/Digital_healthcare_through_Curoflow_white_label_telemedicine_platform.65360ad8.webp";